export default {
    account_change_status_title: "Change Status",
    account_change_the_status_has_been_changed: "The status has been changed",
    account_change_it_was_not_possible_to_change_the_status: "It was not possible to change the status",
    account_change_status_label: "Status",
    account_change_label: "Change",
    account_change_same_status: "The account currently has the same status",
    account_change_status_programmed: "Change of status has been programmed"
};